export const SET_INITIALIZED = (state, payload) => { state.initialized = payload }
export const SET_ENVIRONMENT = (state, payload) => { state.environment = payload }
export const SET_EXPIRATION_DATE = (state) => {
  const date = new Date()
  date.setDate(date.getDate() + 1)
  state.expirationDate = date
}
